import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BaimLanding from "./components/BaimLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BaimLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
